
























































































































import { Vue, Prop, Component } from 'vue-property-decorator';
import {
    ProductSeriesFacetValueViewObject,
    ProductSeriesFacetViewObject, ProductSeriesProductViewObject
} from '@/types/apiServerContract';
import Api from '@/project/http/Api.service';
import { softRedirect } from '@/core/redirect.service';
import { router } from 'spaRouter';
import stockFetchService, { StockViewObjectExtended } from '@/project/product/services/stockFetch.service';
import ProductTileStock from '@/project/product/product-tile/ProductTileStock.vue';
import authService from '@/core/auth/auth.service';
import dictionaryService from '@/core/translation/dictionary.service';
import Dropdown from '@/project/form/Dropdown.vue';
import serverContextService from '@/core/serverContext.service';
import IDropdown from '@/project/form/IDropdown';
import GTMBasics from '@/project/tracking/gtm/GTM.basics';

interface ProductSeriesFacetObject extends ProductSeriesFacetViewObject {
    selectedSeries?: ProductSeriesFacetValueViewObject;
}
interface ProductSeriesObject {
    productSeriesProducts: ProductSeriesProductViewObject[];
    values: ProductSeriesFacetObject[];
}
interface AlternativeSeriesObject {
    displayName: string;
    facetId?: string;
    product: ProductSeriesProductViewObject;
}

@Component({
    components: { Dropdown, ProductTileStock }
})
export default class ProductDetailsSeries extends Vue {
    @Prop({ required: true, type: String }) wid!: string;
    @Prop({ required: true, type: String }) itemId!: string;
    @Prop({ required: true, type: String }) productSeries!: string;
    private series: ProductSeriesObject | null = null;
    private stockData: StockViewObjectExtended[] = [];
    private loaded: boolean = false;
    private stockLoaded: boolean = false;
    private isERPServiceAvailable = true;

    private alternativeSeries: null | AlternativeSeriesObject[][] = null;
    private alternativeSeriesIndex: null | number = null;
    private alternativeSeriesDisplayName: null | string = null;
    private alternativeSeriesFacetId: null | string = null;
    private alternativeSeriesClearOnClose: boolean = false;

    private cancellationCallbacks: (() => void)[] = [];
    $refs!: Vue['$refs'] & {
        dropdown0?: IDropdown,
        dropdown1?: IDropdown,
        dropdown2?: IDropdown,
        dropdown3?: IDropdown
    }

    mounted() {
        if (this.wid && this.productSeries) {
            this.loadProductSeries();
        }
    }

    private async loadProductSeries() {
        this.series = null;
        try {
            const result = await Api.product.series(this.wid, this.productSeries);
            this.series = Object.freeze(result);
            this.series.values.map(series => {
                series.values.map(seriesValue => {
                    if (seriesValue.isSelected) {
                        series.selectedSeries = seriesValue;
                    }
                });
            });
            this.getStockData();
        } catch {
        } finally {
            this.loaded = true;
        }
    }

    private resetStockData() {
        this.stockData = [];
    }

    async getStockData() {
        this.stockLoaded = false;
        this.resetStockData();
        try {
            // eslint-disable-next-line
            this.series?.values.map(ser => ser.values.map(facet => {
                if (facet.itemId) {
                    this.getStockItem(facet.itemId);
                }
            }));
        } catch {
        } finally {
            this.stockLoaded = true;
        }
    }

    async getStockItem(itemId: string) {
        const request = stockFetchService.requestData(itemId);
        this.cancellationCallbacks.push(request.cancel);
        const result = await request.promise;
        if (!this.stockData.find(s => s && s.itemId === itemId)) {
            this.stockData.push(Object.freeze(result));
        }

        this.isERPServiceAvailable = this.isERPServiceAvailable && (result?.isServiceAvailable ?? false);
    }

    private handleClickSeries(selectedSeriesValue:ProductSeriesFacetValueViewObject, seriesIndex: number, seriesItem: ProductSeriesFacetObject) {
        const hasUrl = selectedSeriesValue?.productUrl?.length > 0;
        const isNotCurrentUrl = selectedSeriesValue.productUrl !== router.currentRoute.path;
        const isValidUrl = hasUrl && isNotCurrentUrl;
        this.trackClickProductLink(seriesItem, selectedSeriesValue);
        if (isValidUrl) {
            seriesItem.selectedSeries = selectedSeriesValue;
            softRedirect(selectedSeriesValue.productUrl);
        }
    }

    private getStockByItemId(itemId: string) {
        const stockArray = this.stockData.filter(s => itemId && s.itemId === itemId).map(m => m.stockInformation);
        return stockArray.length ? stockArray[0] : [];
    }

    private get isUserLoggedIn(): boolean {
        return authService.isLoggedIn();
    }

    private getDisplayValue(value: string): string {
        return dictionaryService.translate(value);
    }

    private labelForUnavailableCombination(seriesItem): string {
        const combinationNames = this.series?.values.filter(v => v.facetDisplayName !== seriesItem.facetDisplayName).map(s => s.selectedSeries?.displayValue);
        if (combinationNames) {
            return dictionaryService.get('Product.Series.NotAvailable', [combinationNames.map((n, cIndex) => {
                const c = dictionaryService.translate(n || '');
                if (cIndex === (combinationNames.length - 2)) {
                    return dictionaryService.get('Product.Series.NotAvailablePluralisation', [c]);
                } else if (cIndex === (combinationNames.length - 1)) {
                    return c;
                } else {
                    return `${c}, `;
                }
            }).join('')]);
        }
        return '';
    }

    private handleClickSeriesInvalidOption(seriesItem:ProductSeriesFacetViewObject, seriesOption: ProductSeriesFacetValueViewObject, index: number) {
        const seriesFacetId = seriesItem.facetId.toLowerCase(); // Using to lowercase for some json reason
        const alternativeSeries: AlternativeSeriesObject[][] = [];
        const products = this.series?.productSeriesProducts.filter(p => {
            const obj = Object.keys(p.facetValues);
            const alternativeItems: AlternativeSeriesObject[] = [];
            const objWithFacets = obj.filter((facetId) => {
                alternativeItems.push({
                    product: p,
                    displayName: p.facetValues[facetId],
                    facetId: facetId.toLowerCase()
                });
                return facetId === seriesFacetId && p.facetValues[facetId] === seriesOption.displayValue;
            });
            alternativeSeries.push(alternativeItems);
            return objWithFacets.length;
        });
        if (index === 0) {
            this.alternativeSeriesIndex = 1;
            this.$refs.dropdown0![0]!.closeDropdown();
            this.$refs.dropdown1![0]!.openDropdown();
        } else {
            this.alternativeSeriesIndex = 0;
            this.$refs.dropdown1![0]!.closeDropdown();
            this.$refs.dropdown0![0]!.openDropdown();
        }
        this.alternativeSeries = alternativeSeries;
        this.alternativeSeriesDisplayName = dictionaryService.translate(seriesOption.displayValue);
        this.alternativeSeriesFacetId = seriesFacetId;
        products!.forEach(p => {
            this.getStockItem(p.itemId);
        });
        this.trackClickProductLink(seriesItem, { facetDisplayName: this.getDisplayValue(seriesOption.displayValue), facetId: seriesFacetId });
        this.$nextTick(() => {
            this.alternativeSeriesClearOnClose = true;
        });
    }

    get filteredAlternativeSeriesData(): AlternativeSeriesObject[] | null {
        if (this.alternativeSeries) {
            const items:AlternativeSeriesObject[] = [];
            this.alternativeSeries!.forEach(altSeries => {
                altSeries.forEach(item => {
                    if (item.facetId === this.alternativeSeriesFacetId && this.alternativeSeriesDisplayName === item.product.facetValues[item.facetId]) {
                        const itemCopy = { ...item };
                        const facets = Object.keys(item.product.facetValues);
                        const theOtherFacetId = facets.find((facetId, index) => {
                            return facetId !== item.facetId;
                        });
                        if (theOtherFacetId) {
                            itemCopy.displayName = item.product.facetValues[theOtherFacetId];
                        }
                        items.push(itemCopy);
                    }
                });
            });
            return items || null;
        }
        return null;
    }

    private handleCloseInDropdown() {
        if (this.alternativeSeriesClearOnClose) {
            this.alternativeSeries = null;
            this.alternativeSeriesFacetId = null;
            this.alternativeSeriesDisplayName = null;
            this.alternativeSeriesIndex = null;
            this.alternativeSeriesClearOnClose = false;
        }
    }

    private handleClickInDropdown(seriesItem) {
        this.trackClickSeriesDropdown(seriesItem);
    }

    private handleClickProductSeriesItem(seriesItem, variant) {
        this.trackClickProductLink(seriesItem, variant);
    }

    private trackClickSeriesDropdown(seriesItem) {
        GTMBasics.pushToDataLayer({
            event: 'variant.open',
            variantAttribute: seriesItem.facetDisplayName, // English display name TODO: English
            seriesClassificationId: seriesItem.facetId // ID of the product series classification
        });
    }

    private trackClickProductLink(seriesItem, variant) {
        GTMBasics.pushToDataLayer({
            event: 'variant.click',
            variantAttribute: seriesItem.facetDisplayName || seriesItem.displayValue, // English display name TODO: English
            variantValue: variant.facetDisplayName || variant.displayValue || variant.displayName, // English display name TODO: English
            seriesClassificationId: seriesItem.facetId // ID of the product series classification
        });
    }

    private productDetailsUrl(productAlternative) {
        const product:{ itemId: string, url?: string, mpn?: string } = {
            itemId: productAlternative.itemId,
            url: productAlternative.productUrl
        };
        return serverContextService.productUrl(product);
    }

    private get productDetailsUrlTarget() {
        return serverContextService.externalProductLinkTarget;
    }
}
